import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-loader-pack',
  templateUrl: './loader-pack.component.html',
  styleUrls: ['./loader-pack.component.scss']
})
export class LoaderPackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
